export default __webpack_public_path__ + "static/media/WHATSAPPHEADER.06caa378.png";